import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './../layout';

import { getContactServiceList, getDeviceAccess, getWishList, partnerApi, vendorDashboard , partnerCategory, saveAbout } from './../../../API/FetchCall';

import { Editor } from '@tinymce/tinymce-react';
import { TINY_EDITOR } from '../../../constant';

import 'react-notifications/lib/notifications.css';

import {NotificationContainer, NotificationManager} from 'react-notifications';

class partnerAccountInfo extends Component {

  constructor(props) {
    super(props);
    this.state = {
      user_data: localStorage.getItem('user_data') ? JSON.parse(localStorage.getItem('user_data')) : [],
      authentication: localStorage.getItem('authentication') ? JSON.parse(localStorage.getItem('authentication')) : false,
      first_name: '',
      last_name: '',
      page_data:[],
      dropdown: [],
      data:[],
      about:'',
    }
    this.getPageData();
    
  }

 async getPageData() {
    const { user_type, login_id, set_id } = this.state.user_data;

    let req = JSON.stringify({
      user_type: user_type,
      login_id: login_id,
      sid: set_id,
      url: 'getProfileData'
    });
    partnerApi(req).then(res => {
      if (res.status === 1) {
        let data = res.result;
        this.setState({
          data:data,
          page_data: data.master_data,
          first_name: data.first_name,
          last_name: data.last_name,
        });
      }
    });
  }
  componentDidMount() {

    

  }

   
  handleChangeAbout(value, i) {
    let page_data = this.state.page_data;
    page_data[i]['about'] = value;
    this.setState({about:value});
  }

  toggleInfo(){
      $(".infoEditBlock").toggleClass('hidden');
      let THIS = $('.expandcollapsebtn');
      
      if(THIS.text()==='Expand'){
        THIS.text("Collapse");
      }else{
        THIS.text("Expand");
      }
  }

  submitApprovals = (e) => {
        NotificationManager.success("Thank you, We have received your information for approvals.");
  }

  saveAbout = (e) => {

      let ver_id = $(e.target).attr('data-vid');
      let index = $(e.target).attr('data-index');
      let vertical = $(e.target).attr('data-vertical');
      const { user_type, login_id, set_id } = this.state.user_data;
      if(this.state.about==''){
        NotificationManager.info("Sorry, We notice you have not changed anything.");
      }else{
      let req = JSON.stringify({
        ver_id: ver_id,
        organisation_name:this.state.data.organisation_name,
        login_id: login_id,
        about: this.state.about,
        vertical:vertical
      });

      saveAbout(req).then(res => {
        if (res.status === 1) {
            NotificationManager.success("Thank you, Your About information is submitted");
        }
      });
      }

      //NotificationManager.success("Thank you, Your information is saved");
  }

  render() {
 
    const { cards, collapse,data, page_data, pageurl} = this.state;

        return (
            <React.Fragment>
                <AdminLayout>
                    
              <div class="col-12 grid-margin">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Account Info <span>(What your customer will see)</span></h4>
                   
                  {page_data.map((item, index) => {
                    return (
                        <div class="card">
                            <div class="card-body">
                            
                                <div class="card-title">{item.category_name} : <b>{data.organisation_name} <span style={{fontSize:"10px"}}>{data.set_id==3?"Branch":""}</span></b> <div class="expandcollapsebtn" onClick={this.toggleInfo}>Expand</div>
</div>
                                <div class="addressline"><p className='mar-btm'>{data.address}</p></div>

                                <div class="infoEditBlock hidden">

                                <div class="info-Edit">
                                <div class="titleline-noborder">
                                    <div class="blocktitle-strip">About Info</div>

                                    <div className='inputBlockRow'>
                                        <div class="form-group col-md-12">
                                        <Editor
                                        onEditorChange={(e) => this.handleChangeAbout(e, index)}
                                        value={item.about}
                                        apiKey={TINY_EDITOR}
                                        init={{
                                            height: 400,
                                            plugins: [
                                            'lists link image paste'
                                            ],
                                            toolbar: 'undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | help'
                                        }}
                                            />

                                        
                                        </div>
                                    </div>

                                    <div class="submitBlockRow btnalignright">
                                        <button type='button' data-vertical={item.cid} data-index={index} data-vid={item.mid} onClick={this.saveAbout} id="btnSubmit"
                                            className="btn btn-primary btn-sm">
                                            Submit About info
                                        </button>
                                    </div>

                                </div>
                                </div>

                                <div class="info-Edit">
                                <div class="titleline-noborder">
                                    <div class="blocktitle-strip">Key Information</div>

                                    <div className='inputBlockRow'>
                                         
                                   

                                    </div>

                                    <div class="submitBlockRow btnalignright">
                                        <button type='submit' id="btnSubmit"
                                            className="btn btn-primary btn-sm">
                                            Submit Key info
                                        </button>
                                    </div>

                                </div>
                                </div>

                                <div class="info-Edit">
                                <div class="titleline-noborder">
                                    <div class="blocktitle-strip">Admission Information</div>

                                    <div className='inputBlockRow'>
                                         
                                   

                                    </div>

                                    <div class="submitBlockRow btnalignright">
                                        <button type='submit' id="btnSubmit"
                                            className="btn btn-primary btn-sm">
                                            Submit Admission info
                                        </button>
                                    </div>

                                </div>
                                </div>


                                <div class="info-Edit">
                                <div class="titleline-noborder">
                                    <div class="blocktitle-strip">Gallery</div>

                                    <div className='inputBlockRow'>
                                         
                                   

                                    </div>

                                    <div class="submitBlockRow btnalignright">
                                        <button type='submit' id="btnSubmit"
                                            className="btn btn-primary btn-sm">
                                            Submit Gallery info
                                        </button>
                                    </div>

                                </div>
                                </div> 
                                <div class="info-Edit">
                                <div class="titleline-noborder">
                                    <div class="blocktitle-strip">Videos</div>

                                    <div className='inputBlockRow'>
                                         
                                   

                                    </div>

                                    <div class="submitBlockRow btnalignright">
                                        <button type='submit' id="btnSubmit"
                                            className="btn btn-primary btn-sm">
                                            Submit Videos info
                                        </button>
                                    </div>

                                </div>
                                </div>


                                </div>

                            </div>
                        </div>
                    )
                  })  
                  }
                </div>
              </div>

              
            </div>  


                </AdminLayout>
            </React.Fragment>
        )
    }

}

export default partnerAccountInfo;


// WEBPACK FOOTER //
// ./src/components/bewise/partners/accountinfonew2.jsx